import { render, staticRenderFns } from "./TotalRingChart.vue?vue&type=template&id=2efeedec&scoped=true&"
import script from "./TotalRingChart.vue?vue&type=script&lang=js&"
export * from "./TotalRingChart.vue?vue&type=script&lang=js&"
import style0 from "./TotalRingChart.vue?vue&type=style&index=0&id=2efeedec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efeedec",
  null
  
)

export default component.exports